module.exports = __webpack_public_path__ + "img/slide-1.40744af7.jpg";